import React from 'react';

import { FormattedMessage, FormattedNumber } from 'react-intl';
import * as yup from 'yup';

import message from './LoanRequestDetails.messages';

export default yup.lazy(
    (loanAmount, { currency, maxLoanSize, minLoanSize }) => {
        switch (typeof loanAmount) {
            case 'number':
                const overMaxLoanAmountError = (
                    <MaxAmountError
                        currency={currency}
                        maxAmount={maxLoanSize}
                    />
                );
                const overMinLoanAmountError = (
                    <MinAmountError
                        currency={currency}
                        minAmount={minLoanSize}
                    />
                );

                return yup
                    .number()
                    .max(maxLoanSize, overMaxLoanAmountError)
                    .min(1000, overMinLoanAmountError)
                    .required('Please enter the amount you want to borrow')
                    .typeError('Please enter the amount you want to borrow');

            default:
                return yup
                    .number()
                    .required('Please enter the amount you want to borrow')
                    .typeError('Please enter the amount you want to borrow');
        }
    }
);

class MaxAmountError extends React.Component {
    renderAmountAsCurrency() {
        const { currency, maxAmount } = this.props;

        return (
            <FormattedNumber
                style="currency"
                currencyDisplay="symbol"
                currency={currency}
                value={maxAmount}
            />
        );
    }

    render() {
        const amount = this.renderAmountAsCurrency();
        const messageValues = { amount: amount };

        return (
            <FormattedMessage
                {...message.maxAmountError}
                values={messageValues}
            />
        );
    }
}

class MinAmountError extends React.Component {
    renderAmountAsCurrency() {
        const { currency, minAmount } = this.props;

        return (
            <FormattedNumber
                style="currency"
                currencyDisplay="symbol"
                currency={currency}
                value={minAmount}
            />
        );
    }

    render() {
        const amount = this.renderAmountAsCurrency();
        const messageValues = { amount: amount };

        return (
            <FormattedMessage
                {...message.minAmountError}
                values={messageValues}
            />
        );
    }
}
